import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

const StyledCircle = styled.circle`
  stroke: ${(props) => props.theme.highlight};
  stroke-width: 14px;
`

const Elevator = ({num, colors}) => {
   const elevatorImages = [
      <g>
         <g>
            <StyledCircle fill={colors.ocean} cx="1133.16" cy="2596.38" r="27.04"/>
            <StyledCircle fill={colors.ocean} cx="756.55" cy="2931.72" r="85.12"/>
            <line strokeWidth="14px" x1="1112.96" y1="2614.37" x2="820.12" y2="2875.12"/>
         </g>
         <g>
            <StyledRect x="480.3" y="2813.74" width="151.94" height="151.94"/>
            <path d="M622.84,2823.74v132.53H490.3V2823.74H622.84m10-10H480.3v152.53H632.84V2813.74Z"/>
            <path d="M551.82,2862.38H534.57v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>,

      <g>
         <g>
            <StyledCircle fill={colors.ocean} cx="1393.12" cy="1128.14" r="27.04"/>
            <StyledCircle fill={colors.ocean} cx="1126.95" cy="699.85" r="85.12"/>
            <line strokeWidth="14px" x1="1378.85" y1="1105.17" x2="1171.88" y2="772.14"/>
         </g>
         <g>
            <StyledRect x="1245.39" y="557.12" width="151.35" height="151.35"/>
            <path d="M1387.38,567.08v132h-132v-132h132m10-10H1245.39V709.06h151.95V557.12Z"/>
            <path d="M1316.63,605.57h-17.18V593.92c13.9,0,18.83-3,22.56-13.15h11.06V685.36h-16.44Z"/>
         </g>
      </g>,

      <g>
         <g>
            <StyledCircle fill={colors.ocean} cx="3016.22" cy="1694.56" r="27.04"/>
            <StyledCircle fill={colors.ocean} cx="3504.88" cy="1570.06" r="85.12"/>
            <line strokeWidth="14px" x1="3042.43" y1="1687.88" x2="3422.39" y2="1591.08"/>
         </g>
         <g>
            <StyledRect x="3623.77" y="1408.65" width="151.94" height="151.94"/>
            <path d="M3766.31,1418.65v132.53H3633.77V1418.65h132.54m10-10H3623.77v152.53h152.54V1408.65Z"/>
            <path d="M3695.29,1457.29H3678v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
         </g>
      </g>
   ]

  const index = num-1

  return (
   elevatorImages[index]
  )
}

export default Elevator
